import { useErrorHandler, useTranslate } from '@repo/shared/hooks'
import { FormSchema, useAppForm } from '@repo/ui/hooks'

import { useLoginSchema } from '@repo/auth/schemas'
import { handleNumericInput, handlePasteInput } from '@repo/tools'
import { useAgentPhoneOtp } from '@repo/services'
import {
  Alert,
  Button,
  Form,
  FormField,
  FormItemWrapper,
  Input,
} from '@repo/ui/components'
import { normalizeMobile } from '@repo/ui/lib'
import { IChangeMobileKycFormProps } from './change-mobile-kyc.types'

export const ChangeMobileKycForm = (props: IChangeMobileKycFormProps) => {
  const { onSuccess, mobile } = props
  const { t } = useTranslate()
  const { mobileSchema } = useLoginSchema()
  const { form } = useAppForm({
    formSchema: mobileSchema,
    defaultValues: {
      mobile: mobile,
    },
  })
  const phoneOtpMutation = useAgentPhoneOtp()
  const { errorHandler } = useErrorHandler()

  const onSubmit = (data: FormSchema<typeof mobileSchema>) => {
    phoneOtpMutation.mutate(
      { phone: normalizeMobile(data.mobile) },
      {
        onSuccess: (res) => onSuccess(data.mobile, res?.data?.otp ?? 0),
        onError: errorHandler,
      },
    )
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className='space-y-3xl w-full'
      >
        <Alert color='base' caption={t('changeMobileKyc_alert')} hideIcon />
        <FormField
          control={form.control}
          name='mobile'
          render={({ field }) => (
            <FormItemWrapper
              title={t('common_mobileNumber')}
              caption={t('changeMobileKyc_mobileStartsWithZero')}
              inputSize='lg'
            >
              <Input
                autoComplete='off'
                type='text'
                className='ltr'
                inputSize='lg'
                variant={'fill'}
                {...field}
                onKeyDown={(e) => handleNumericInput(e, 11)}
                onPaste={(e) => handlePasteInput(e, 11)}
              />
            </FormItemWrapper>
          )}
        />
        <Button
          className='w-full'
          type='submit'
          variant='ghost'
          size='md'
          color='base'
          loading={phoneOtpMutation.isPending}
        >
          {t('common_continue')}
        </Button>
      </form>
    </Form>
  )
}
